import { routes } from "./routes";

const getExcludedPaths = (): string[] => [
  // `/${orgId}`,
  // `/${orgId}/${routes.public.signIn}`,
  // `/${orgId}/${routes.public.signUp}`,
  // `/${orgId}/${routes.public.forgotPassword}`,
  // `/${orgId}/${routes.public.setPassword}`,
  // `/${orgId}/${routes.public.resetConfirm}`,
  // `/${orgId}/${routes.public.signUpConfirm}`,
  // `/${orgId}/${routes.public.autoLogin}`,
  // `/${orgId}/customer/home`,
  // `/${orgId}/seller/invoice-screen`,
  // `/${orgId}/seller/dashboard/sales`,
  // `/${orgId}/seller/dashboard/salesrep-analytics`,
  // `/${orgId}/seller/dashboard/client-analytics`,
  // `/${orgId}/seller/dashboard/finance-analytics`,
  // `/${orgId}/sales-rep/dashboard/sales`,
  // `/${orgId}/sales-rep/dashboard/salesrep-analytics`,
  // Add clean URL patterns for compatibility
  `/${routes.public.signIn}`,
  `/${routes.public.signUp}`,
  `/${routes.public.forgotPassword}`,
  `/${routes.public.setPassword}`,
  `/${routes.public.resetConfirm}`,
  `/${routes.public.signUpConfirm}`,
  `/${routes.public.autoLogin}`,
  `/maltora-customer/home`,
  `/maltora-seller/invoice-screen`,
  `/maltora-seller/dashboard/sales`,
  `/maltora-seller/dashboard/salesrep-analytics`,
  `/maltora-seller/dashboard/client-analytics`,
  `/maltora-seller/dashboard/finance-analytics`,
  `/maltora-sales-rep/dashboard/sales`,
  `/maltora-sales-rep/dashboard/salesrep-analytics`,
];

export { getExcludedPaths };
